// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__JDh4T","logoImg":"Logo_logoImg__oXfr5","animateLogo":"Logo_animateLogo__DJS7H","logoPulse":"Logo_logoPulse__xicnt"};